'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var string = _propTypes2.default.string,
    array = _propTypes2.default.array;


function MenuGroup(props) {
  return _react2.default.createElement(
    _reactBootstrap.Col,
    { md: 4, sm: 6, xs: 12 },
    _react2.default.createElement(
      'div',
      { className: _style2.default.group },
      _react2.default.createElement(
        'div',
        { className: _style2.default.title },
        _typeof(props.links[0]) === 'object' ? _react2.default.createElement(
          'a',
          { href: '#' + props.links[0].href },
          _react2.default.createElement('i', { className: 'fa fa-' + (props.icon || 'file') + ' fa-fw' }),
          props.title
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('i', { className: 'fa fa-' + (props.icon || 'file') + ' fa-fw' }),
          props.title
        )
      ),
      _react2.default.createElement(
        'ul',
        null,
        props.links.map(function (link, index) {
          return _react2.default.createElement(
            'li',
            { key: index },
            _react2.default.createElement(
              'a',
              { href: '#' + link.href },
              link.title
            )
          );
        })
      )
    )
  );
}
MenuGroup.propTypes = {
  title: string.isRequired,
  icon: string.isRequired,
  links: array.isRequired
};
/*
    <div className={style.group}>
      <div className={style.title}>
        <a href={`#${props.links[0].href}`}>
          <i className={`fa fa-${props.icon} fa-fw`} />
          {props.title}
        </a>
      </div>
      <ul>
        {
          props.links.map((link, index) => (
            <li key={index}>
              <a href={`#${link.href}`}>{link.title}</a>
            </li>
          ))
        }
      </ul>
    </div>
*/
function Menu(props) {
  return _react2.default.createElement(
    'div',
    { className: _style2.default.main },
    _react2.default.createElement(
      _reactBootstrap.Grid,
      null,
      props.groups.map(function (group) {
        return _react2.default.createElement(MenuGroup, {
          key: group.title,
          title: group.title,
          icon: group.icon || 'file',
          links: group.links
        });
      })
    )
  );
}
Menu.propTypes = {
  groups: array.isRequired
};

exports.default = Menu;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Menu/Menu.js
// module id = 1311
// module chunks = 0